import script from "./ProjectVotersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectVotersPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectVotersPage.vue?vue&type=style&index=0&id=1f23b69e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f23b69e"]])

export default __exports__